import { filterObjectByKeys, getLanguage, saveToStorage } from "./utilities";

const lang = getLanguage();

function storePrintValues({
    assetMixes,
    assetMixesInfo,
    investmentAmount,
    investmentGrowth,
    bestAndWorst,
    timePeriods,
    timeToRecover
}) {
    function getAssetMixPrintValues(assetMix) {
        const assetMixInfo = assetMixesInfo[assetMix];
        const colour = assetMixInfo.colours.print;
        const alt = `${colour} legend`;
        const colourSrc = `circle-${colour}.png`;
        const label = assetMixInfo.label[lang];
        const pieSrc = assetMixInfo.image;
        const shortLabel = assetMixInfo.label[lang].replace(/[^\d/]/g, "");

        const assetMixKey = assetMixes.indexOf(assetMix) < 1 ? "assetMixOne" : "assetMixTwo";
        const bestYear = filterObjectByKeys(investmentGrowth[assetMixKey].filter(({ bestYear }) => bestYear)[0], [
            "bestYear",
            "portfolioValue"
        ]);
        const worstYear = filterObjectByKeys(investmentGrowth[assetMixKey].filter(({ worstYear }) => worstYear)[0], [
            "worstYear",
            "portfolioValue"
        ]);

        const darkColourSrc = colourSrc;
        const lightColourSrc = `circle-light-${colour}.png`;

        const [threeMonths, oneYear, threeYears, fiveYears] = timeToRecover[assetMixKey]
            .filter(({ month }) => month === 3 || month === 15 || month === 39 || month === 63)
            .map(({ portfolioValue }) => portfolioValue);
        const recoveryTimePeriod = Math.ceil(
            timeToRecover[assetMixKey].filter(({ recoveryMonth }) => recoveryMonth)[0].month - 3
        );

        return {
            alt,
            bestAndWorst: {
                darkColourSrc,
                lightColourSrc
            },
            colourSrc,
            investmentGrowth: {
                bestYear,
                worstYear
            },
            label,
            pieSrc,
            shortLabel,
            timeToRecover: {
                portfolioValues: {
                    threeMonths,
                    oneYear,
                    threeYears,
                    fiveYears
                },
                recoveryTimePeriod
            }
        };
    }

    const [assetMixOne, assetMixTwo] = assetMixes;
    const { graphSrc: investmentGrowthGraphSrc } = investmentGrowth;
    const { graphSrc: timeToRecoverGraphSrc } = timeToRecover;

    let assetMixPrintValues = getAssetMixPrintValues(assetMixOne);
    let value = {
        assetMixOne: {
            alt: assetMixPrintValues.alt,
            colourSrc: assetMixPrintValues.colourSrc,
            label: assetMixPrintValues.label,
            pieSrc: assetMixPrintValues.pieSrc,
            shortLabel: assetMixPrintValues.shortLabel
        },
        bestAndWorst: {
            ...bestAndWorst,
            assetMixOne: {
                ...bestAndWorst.assetMixOne,
                ...assetMixPrintValues.bestAndWorst
            },
            timePeriod: timePeriods.bestAndWorst
        },
        investmentAmount,
        investmentGrowth: {
            assetMixOne: assetMixPrintValues.investmentGrowth,
            graphSrc: investmentGrowthGraphSrc
        },
        timeToRecover: {
            assetMixOne: assetMixPrintValues.timeToRecover,
            graphSrc: timeToRecoverGraphSrc,
            timePeriod: timePeriods.timeToRecover
        }
    };

    if (assetMixTwo !== undefined) {
        assetMixPrintValues = getAssetMixPrintValues(assetMixTwo);
        value = {
            ...value,
            assetMixTwo: {
                alt: assetMixPrintValues.alt,
                colourSrc: assetMixPrintValues.colourSrc,
                label: assetMixPrintValues.label,
                pieSrc: assetMixPrintValues.pieSrc,
                shortLabel: assetMixPrintValues.shortLabel
            },
            bestAndWorst: {
                ...value.bestAndWorst,
                assetMixTwo: {
                    ...value.bestAndWorst.assetMixTwo,
                    ...assetMixPrintValues.bestAndWorst
                }
            },
            investmentGrowth: {
                ...value.investmentGrowth,
                assetMixTwo: assetMixPrintValues.investmentGrowth
            },
            timeToRecover: {
                ...value.timeToRecover,
                assetMixTwo: assetMixPrintValues.timeToRecover
            }
        };
    }

    saveToStorage("assetallocation", value);
}

export { storePrintValues };
